(function($){
	var open = {
		langmenu : function($elm){
			window.location.href = "/language/";
		},
		search : function($elm){
			window.location.href = "/site_search/ja/search.php";
		}
	};

	var tasks = {
		open : function(type, $elm){
			$elm.on("click", function(event){
				if(!!open[type] && typeof open[type] == "function"){
					open[type]($elm);
				}
				event.preventDefault();
			});
		}
	};

	var headerOffset = function(){
		var utilbarOffset = $('#l-utility').get(0).getBoundingClientRect().bottom;
		var headerOffset = $('header.l-header').get(0).getBoundingClientRect().bottom;
		return Math.max(utilbarOffset, headerOffset)
	};
	
	var scrollToElement = function($dest, offset){
	
		var $bottomMeasureElement = (function(){
			var $bottom = $('<div>').css("height", "0px");
			$(document.body).append($bottom);
			return $bottom;
		})();
		var currentY = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
		
		var scroll = function(){
			var targetY = $dest.get(0).getBoundingClientRect().top + currentY - document.documentElement.clientTop - (headerOffset() + (offset || 0));
			
			var reqCount = 600 / (1000 / 60);
			var rate = (targetY - currentY) / reqCount;
			var cnt = 0;
			var renderer = function(){
				if(cnt++ == reqCount){
					$bottomMeasureElement.remove();
					return;
				}
				window.scrollTo(0, currentY + rate * cnt);
				window.requestAnimationFrame(renderer);
			};
			window.requestAnimationFrame(renderer);
		};
		
		var lim = 123;
		var ready = window.setInterval(function(){
			var contextHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
			var bottomPosition = $bottomMeasureElement.get(0).getBoundingClientRect().top + currentY - document.documentElement.clientTop;
			// console.log(bottomPosition + " " + contextHeight);
			
			if(bottomPosition <= contextHeight + 1){
				window.clearInterval(ready);
				scroll();
			}
			if(lim-- == 0 || $(document.documentElement).hasClass("is-firefox")){
				window.clearInterval(ready);
			}
		}, 100);
		

		
	};
	
	var scrollToTarget = function(dest){
		if($('#' + dest).length == 0){
			return;
		}
		scrollToElement($('#' + dest));
	};
	
	OH.scrollToElement = scrollToElement;

	OH.anchorController = function($link){
		var href = $link.attr("href");
		if(href.indexOf("#") == 0){
			href = href.substring("#".length);
			if(!href){
				$link.attr("href", location.href);
				$link.on("click", function(event){
					event.preventDefault();
				});
			}
			else if(href.indexOf(":") < 0){
				$link.on("click", function(event){
					event.preventDefault();
					scrollToTarget(href);
				});
			}
			else{
				href = href.split(":");
				if(!!tasks[href[0]] && typeof tasks[href[0]] == "function"){
					tasks[href[0]](href[1], $link);
				}
			}
		}
		//else{}
	};
	
	var setHashScroll = function(force){
		var targetHash = !!force ? force : location.hash;
		if(!!targetHash && targetHash.indexOf(OH.settings.vueDefine.hashPrefix) > 0){
			$('[id]').each(function(){
				var id = $(this).attr("id");
				if(id.match(/flg\-[\w]+\-search/)){
					// scrollToTarget(id);
					return false;
				}
			});
		}
		else if(!!targetHash){
			// scrollToTarget(targetHash.slice("#".length));
		}
	};
	// $(window).on("load", function(){
	// 	setHashScroll();
	// });

	OH.setHashScroll = setHashScroll;
	
	var setGaTrigger = function($parent, type){
		var types = {
			vue : {
				query : ".c-thumbnail > A",
				label : "Contents Area OH"
			},
			modal : {
				query : ".c-infoModal A",
				label : "Modal Area OH"
			},
			aside : {
				query : ".l-body__aside A",
				label : "Connect Area OH"
			},
			snsgp : {
				query : ".c-pageHeader__shareLinks A.shareGp",
				label : "Share GooglePlus OH"
			},
			snsfb : {
				query : ".c-pageHeader__shareLinks A.shareFb",
				label : "Share Facebook OH"
			},
			snstw : {
				query : ".c-pageHeader__shareLinks A.shareTw",
				label : "Share Twitter OH"
			},
			snsli : {
				query : ".c-pageHeader__shareLinks A.shareLi",
				label : "Share Line OH"
			},
			pcgnav : {
				query : ".l-header__nav__dropdown__item A",
				label : "Global Navigation Area OH"
			},
			pcmega : {
				query : ".l-header__nav__menu__content__link A,.l-header__nav__menu__title A,.l-header__nav__menu__content__thumbnail A,.l-header__nav__menu__category.is-staticContents A",
				label : "Mega Menu Area OH"
			},
			spgnav : {
				query : ".l-header__nav__sp__item A",
				label : "Global Navigation Area OH"
			}
		};
		$parent.find(types[type].query).each(function(){
			var anchor = $(this);
			anchor.on("click", function(event){
				window.send_ga("send", "event", types[type].label, "Click", anchor.attr("href"), {'nonInteraction' : 1});
			});
		});
	};
	OH.setGaTrigger = setGaTrigger;
	
	$(function(){
		setGaTrigger($("body"), "modal");
		setGaTrigger($("body"), "aside");
		setGaTrigger($("body"), "snsgp");
		setGaTrigger($("body"), "snsfb");
		setGaTrigger($("body"), "snstw");
		setGaTrigger($("body"), "snsli");
		setGaTrigger($("body"), "pcgnav");
		setGaTrigger($("body"), "pcmega");
		setGaTrigger($("body"), "spgnav");
	});
})(jQuery);
